module.exports = "/images/gotham-13.jpg";